import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/NavBar/NavBar';
import Competition from './components/Competition/Competition';
import Members from './components/Members/Members';
import ContactForm from './components/ContactForm/ContactForm';
import HeroSection from './components/HeroSection/HeroSection';
import i18n from 'i18next';

function App() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 900);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 900);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const savedLanguage = localStorage.getItem('language') || 'en';
    i18n.changeLanguage(savedLanguage);
  }, []);

  return (
    <Router>
      <Navbar
        isMobile={isMobile}
        isMenuOpen={isMenuOpen}
        setIsMenuOpen={setIsMenuOpen}
      />
      <div className="container">
        <Routes>
          {/* Default Redirect */}
          <Route path="/" element={<Navigate to="/en/home" replace />} />

          {/* English Routes */}
          <Route
            path="/en/home"
            element={<HeroSection isMobile={isMobile} isMenuOpen={isMenuOpen} />}
          />
          <Route
            path="/en/competition"
            element={<Competition isMobile={isMobile} isMenuOpen={isMenuOpen} />}
          />
          <Route
            path="/en/members"
            element={<Members isMobile={isMobile} isMenuOpen={isMenuOpen} />}
          />
          <Route
            path="/en/contact"
            element={<ContactForm isMobile={isMobile} isMenuOpen={isMenuOpen} />}
          />

          {/* Portuguese Routes */}
          <Route
            path="/pt/home"
            element={<HeroSection isMobile={isMobile} isMenuOpen={isMenuOpen} />}
          />
          <Route
            path="/pt/competition"
            element={<Competition isMobile={isMobile} isMenuOpen={isMenuOpen} />}
          />
          <Route
            path="/pt/members"
            element={<Members isMobile={isMobile} isMenuOpen={isMenuOpen} />}
          />
          <Route
            path="/pt/contact"
            element={<ContactForm isMobile={isMobile} isMenuOpen={isMenuOpen} />}
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
